var React = require('react');

function TrendingUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.9999 12C23.9999 12.5523 23.5522 13 22.9999 13C22.4476 13 21.9999 12.5523 21.9999 12V8.41406L14.207 16.207C13.8164 16.5976 13.1834 16.5976 12.7929 16.207L8.49992 11.9141L1.70696 18.707C1.31643 19.0976 0.683418 19.0976 0.292893 18.707C-0.0976311 18.3165 -0.0976311 17.6835 0.292893 17.293L7.79289 9.79297L7.86907 9.72461C8.26184 9.40426 8.84084 9.42685 9.20696 9.79297L13.4999 14.0859L20.5859 7H16.9999C16.4476 7 15.9999 6.55228 15.9999 6C15.9999 5.44772 16.4476 5 16.9999 5H22.9999C23.5522 5 23.9999 5.44772 23.9999 6V12Z"}));
}

TrendingUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = TrendingUp;

TrendingUp.default = TrendingUp;
